// React imports
import React from 'react';
import { useForm } from 'react-hook-form';

// Material-UI imports

// Other imports
import { useMutation } from '@apollo/client';
// @ts-ignore
import { yupResolver } from '@hookform/resolvers/yup';
// @ts-ignore
import * as yup from 'yup';

// Absolute imports
import { capTableReportGenerate } from 'modules/capTableReport/mutations';

// Relative imports

type FormData = {
  date: string;
  email1: string;
  email2: string;
};

const schema = yup.object().shape({
  date: yup.date().required('Please enter a date.').typeError('Please enter a date.'),
  email1: yup
    .string()
    .email('Please enter a valid email address.')
    .required('Please enter an email'),
  email2: yup
    .string()
    .email('Please enter a valid email address.')
    .required('Please enter an email')
    .oneOf([yup.ref('email1'), null], 'Email does not match'),
});

export function useCapTableReport(fundInvestmentId: string, open: boolean, onClose: () => void) {
  const [generateReport] = useMutation(capTableReportGenerate);

  // States
  const [showAlert, setShowAlert] = React.useState<boolean>(false);
  const [isOpen, setIsOpen] = React.useState(false);

  // Hooks
  const form = useForm<FormData>({
    mode: 'onChange',
    defaultValues: {
      date: new Date().toISOString().substring(0, 10),
      email1: '',
      email2: '',
    },
    //@ts-ignore
    resolver: yupResolver(schema),
  });
  const { date, email1, email2 } = form.watch();

  // Effects
  React.useEffect(() => {
    if (date || email1 || email2) setShowAlert(false);
  }, [date, email1, email2]);

  React.useEffect(() => {
    setIsOpen(open);
  }, [open]);

  // Functions
  const close = () => {
    setIsOpen(false);
    onClose();
  };

  const onSubmit = () => {
    form.handleSubmit(async (data: FormData) => {
      const response = await generateReport({
        variables: {
          investmentId: fundInvestmentId,
          email: data.email1,
          asOfDate: new Date(data.date).toISOString().substring(0, 10),
        },
      });
      if (response.data.capTableReportGenerate.success) {
        onClose();
      } else {
        setShowAlert(true);
      }
    })();
  }

  return {
    form,
    showAlert,
    isOpen,
    onClose: close,
    onSubmit,
  };
}
